import Form from "../modules/form";

const SingleService = {
  init() {
    Form.init();
  },
};
export default SingleService;
